import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/layouts/home.vue';
import Layout from '@/layouts/layout.vue';
// import Empty from '@/views/common/empty.vue';
// import Error from '@/views/common/errorPage.vue';
import Collect from '@/layouts/Collect.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'appointment',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'appointment',
        meta: {
          goBack: false,
          toolBar: 'visitorSh',
        },
        component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/visitor/index.vue'),
      },
      {
        path: '/record',
        name: 'recordSearch',
        meta: {
          goBack: false,
          toolBar: 'visitorSh',
        },
        component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/visitor/record.vue'),
      },
    ],
  },

  {
    path: '/avatarUpload/:id',
    name: 'uploadAvatar',
    meta: {
      goBack: false,
    },
    component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/visitor/uploadImage.vue'),
  },
  // {
  //   path: '/',
  //   name: 'error',
  //   meta: {
  //     goBack: false,
  //   },
  //   component: Error,
  // },
  // {
  //   path: '/',
  //   name: 'empty',
  //   meta: {
  //     goBack: false,
  //   },
  //   component: Empty,
  // },
  {
    path: '/info',
    name: 'visitorInfo',
    meta: {
      goBack: false,
      auth: false,
    },
    component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/info.vue'),
  },
  {
    path: '/appointment',
    name: 'appointment',
    meta: {
      goBack: false,
      toolBar: 'visitorSh',
      // auth: false,
    },
    component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/visitor/index.vue'),
  },

  {
    path: '/parking',
    name: 'appointmentParking',
    meta: {
      goBack: true,
      // auth: false,
    },
    component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/visitor/parking.vue'),
  },
  {
    path: '/parking/space',
    name: 'appointmentParkingSpace',
    meta: {
      goBack: true,
      // auth: false,
    },
    component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/visitor/parkingSpace.vue'),
  },
  {
    path: 'apply/result',
    name: 'appointmentResult',
    meta: {
      goBack: true,
      // auth: false,
    },
    component: () => import(/* webpackChunkName: "visitorApplyResult" */ '@/views/common/success.vue'),
  },
  {
    path: 'invitation/result',
    name: 'invitationResult',
    meta: {
      goBack: true,
      // auth: false,
    },
    component: () => import(/* webpackChunkName: "visitorApplyResult" */ '@/views/noAuth/visitor/success.vue'),
  },
  {
    path: '',
    redirect: { name: 'appointment' },
  },
  {
    path: '*',
    redirect: { name: 'appointment' },
  },
  {
    path: '/user/login',
    name: 'userInfo',
    meta: {
      goBack: false,
      auth: false,
    },
    component: () => import(/* webpackChunkName: "visitorInfo" */ '@/views/noAuth/login.vue'),
  },
  {
    path: '/:id',
    component: Home,
    name: 'home',
    meta: {
      goBack: false,
    },
    children: [
      {
        path: '/',
        name: 'homeModule',
        meta: {
          goBack: false,
          auth: true,
        },
        component: () => import(/* webpackChunkName: "registerResult" */ '@/views/modules/home.vue'),
      },
      // auth
      {
        path: 'auth',
        name: 'auth',
        component: Layout,
        children: [
          {
            path: 'login',
            name: 'login',
            meta: {
              goBack: false,
            },
            component: () => import(/* webpackChunkName: "login" */ '@/views/auth/login.vue'),
          },
          {
            path: 'register',
            name: 'register',
            meta: {
              goBack: false,
            },
            component: () => import(/* webpackChunkName: "register" */ '@/views/auth/register.vue'),
          },
          {
            path: 'register/result',
            name: 'registerResult',
            meta: {
              goBack: true,
            },
            component: () => import(/* webpackChunkName: "registerResult" */ '@/views/common/success.vue'),
          },
          {
            path: '',
            redirect: { name: 'login' },
          },
          {
            path: '*',
            redirect: { name: 'login' },
          },
        ],
      },
      {
        path: 'identify',
        name: 'identify',
        component: Layout,
        children: [
          {
            path: '',
            name: 'identification',
            component: () => import(/**/ '@/views/modules/identification'),
            meta: {
              header: false,
            },
          },
        ],
      },
      // visitor
      {
        path: 'visitor',
        name: 'visitor',
        component: Layout,
        children: [
          {
            path: 'apply',
            name: 'visitorApply',
            meta: {
              goBack: false,
              auth: false,
            },
            component: () => import(/* webpackChunkName: "visitorApply" */ '@/views/modules/visitor/apply.vue'),
          },
          {
            path: 'apply/result',
            name: 'visitorApplyResult',
            meta: {
              goBack: true,
              auth: false,
            },
            component: () => import(/* webpackChunkName: "visitorApplyResult" */ '@/views/common/success.vue'),
          },
          {
            path: 'option/reject',
            name: 'visitorOptionReject',
            meta: {
              goBack: true,
              auth: true,
            },
            component: () => import(/* webpackChunkName: "visitorOptionReject" */ '@/views/modules/visitor/reject.vue'),
          },
          {
            path: 'option/proceed',
            name: 'visitorOptionProceed',
            meta: {
              goBack: true,
              auth: true,
            },
            component: () =>
              import(/* webpackChunkName: "visitorOptionProceed" */ '@/views/modules/visitor/proceed.vue'),
          },
          {
            path: 'option/result',
            name: 'visitorOptionResult',
            meta: {
              goBack: true,
              auth: true,
            },
            component: () => import(/* webpackChunkName: "visitorOptionResult" */ '@/views/common/success.vue'),
          },
          {
            path: 'user/review',
            name: 'visitorUserReview',
            meta: {
              goBack: false,
              auth: true,
              toolBar: 'visitor',
            },
            component: () => import(/* webpackChunkName: "visitorUserReview" */ '@/views/modules/visitor/review.vue'),
          },
          {
            path: 'user/apply',
            name: 'visitorUserApply',
            meta: {
              goBack: false,
              auth: true,
              toolBar: 'visitor',
            },
            component: () => import(/* webpackChunkName: "visitorUserApply" */ '@/views/modules/visitor/invite.vue'),
          },
          {
            path: 'user/apply/result',
            name: 'visitorUserApplyResult',
            meta: {
              goBack: true,
              auth: true,
            },
            component: () => import(/* webpackChunkName: "visitorUserApplyResult" */ '@/views/common/success.vue'),
          },
          {
            path: 'user/history',
            name: 'visitorUserHistory',
            meta: {
              goBack: false,
              auth: true,
              toolBar: 'visitor',
            },
            component: () => import(/* webpackChunkName: "visitorUserHistory" */ '@/views/modules/visitor/history.vue'),
          },
          {
            path: '',
            redirect: { name: 'visitorApply' },
          },
          {
            path: '*',
            redirect: { name: 'visitorApply' },
          },
        ],
      },
      {
        path: 'meeting',
        name: 'meeting',
        component: Layout,
        children: [
          {
            path: 'booking',
            name: 'meetingBooking',
            meta: {
              goBack: false,
              toolBar: 'meeting',
              auth: true,
            },
            component: () => import(/* webpackChunkName: "meetingBooking" */ '@/views/modules/meeting/booking.vue'),
          },
          {
            path: 'info/:conferenceId',
            name: 'meetingInfo',
            meta: {
              goBack: true,
              auth: true,
            },
            component: () => import(/* webpackChunkName: "meetingInfo" */ '@/views/modules/meeting/meetingInfo.vue'),
          },
          {
            path: 'room/:roomId',
            name: 'meetingRoom',
            meta: {
              goBack: true,
              auth: true,
            },
            component: () => import(/* webpackChunkName: "meetingRoom" */ '@/views/modules/meeting/meetingRoom.vue'),
          },
          {
            path: 'check/:conferenceId',
            name: 'meetingCheck',
            meta: {
              goBack: true,
              auth: true,
              toolBar: '',
            },
            component: () => import(/* webpackChunkName: "meetingCheck" */ '@/views/modules/meeting/checkInfo.vue'),
          },
          {
            path: 'add',
            name: 'meetingAdd',
            meta: {
              goBack: true,
              auth: true,
              toolBar: '',
            },
            component: () => import(/* webpackChunkName: "meetingAdd" */ '@/views/modules/meeting/meetingAdd.vue'),
          },
          {
            path: 'edit/:conferenceId',
            name: 'meetingEdit',
            meta: {
              goBack: true,
              auth: true,
              toolBar: '',
            },
            component: () => import(/* webpackChunkName: "meetingEdit" */ '@/views/modules/meeting/meetingEdit.vue'),
          },
          {
            path: 'selectRoom',
            name: 'meetingSelectRoom',
            meta: {
              goBack: true,
              auth: true,
              toolBar: '',
            },
            component: () =>
              import(/* webpackChunkName: "meetingSelectRoom" */ '@/views/modules/meeting/selectRoom.vue'),
          },
          {
            path: 'selectPerson',
            name: 'meetingSelectPerson',
            meta: {
              goBack: true,
              toolBar: '',
              auth: true,
            },
            component: () =>
              import(/* webpackChunkName: "meetingSelectPerson" */ '@/views/modules/meeting/selectPerson.vue'),
          },
          {
            path: 'booking/result',
            name: 'meetingResult',
            meta: {
              goBack: true,
              auth: true,
            },
            component: () => import(/* webpackChunkName: "meetingResult" */ '@/views/common/success.vue'),
          },
          {
            path: 'user',
            name: 'meetingUser',
            meta: {
              goBack: false,
              toolBar: 'meeting',
              auth: true,
            },
            component: () => import(/* webpackChunkName: "meetingUser" */ '@/views/modules/meeting/myMeeting.vue'),
          },
          {
            path: '',
            redirect: { name: 'meetingBooking' },
          },
          {
            path: '*',
            redirect: { name: 'meetingBooking' },
          },
        ],
      },
      // 私有化版本。
      {
        path: 'collect/private/:userId',
        component: Collect,
        name: 'collectPrivate',
        meta: {
          header: false,
        },
        children: [
          {
            path: 'verify',
            name: 'collectVerify',
            meta: {
              header: false,
            },
            component: () => import('@/views/auth/Verify.vue'),
          },
          {
            path: 'info',
            name: 'collectPrivateInfo',
            meta: {
              header: false,
            },
            beforeEnter: (to, from, next) => {
              // 如果是身份验证通过的话就会有参数信息，此时可以正常上传。
              // 其它情况比如随便输入的 url 或者刷新当前页面都需要重新验证身份。
              const {
                params: { auth },
              } = to;
              if (!auth) {
                const path = to.path.replace('info', 'verify');
                return next({
                  // 因为路由包含参数匹配，这里 router 似乎会丢失 params 和 query 等信息，直接使用 name 导致无法正常匹配。
                  // name: 'collectVerify',
                  path,
                });
              }
              next();
            },
            component: () => import('@/views/modules/collect/CollectInfo'),
          },
          {
            path: '',
            redirect: { name: 'collectVerify' },
          },
        ],
      },
      // 基线版本不需要身份验证。
      {
        path: 'collect/public/:userId/',
        component: Collect,
        name: 'collectPublic',
        meta: {
          header: false,
        },
        children: [
          {
            path: 'info',
            name: 'collectPublicInfo',
            meta: {
              header: false,
            },
            component: () => import('@/views/modules/collect/CollectInfo'),
          },
          {
            path: '*',
            redirect: { name: 'collectPublicInfo' },
          },
        ],
      },
      {
        path: '',
        redirect: { name: 'homeModule' },
      },
      {
        path: '*',
        redirect: { name: 'homeModule' },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
